import $ from "jquery";
import * as actions from "../actions/actions";
import { connect } from "react-redux";
import { hashHistory } from "react-router";
import React from "react";

import Loading from "./loading";
import Icon from "./nounproject-ui-icon";
import PluginToolbar from "./plugin-toolbar";
import PluginFooter from "./plugin-footer";

class PluginFeedback extends React.Component {
    // TODO: Autofill email if logged in

    constructor(props) {
        super(props);
        this.state = {
            commentError: false,
            emailError: false,
            loading: false,
            sent: false
        };
    }

    closeFeedback(e) {
        e.preventDefault();
        hashHistory.push("search");
    }

    validateEmail(email) {
        var re = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
        return re.test(email);
    }

    submitFeedback(e) {
        e.preventDefault();
        let $this = this,
            appInfo,
            email = $("#email").val(),
            emailHasError,
            comment = $("#feedback").val(),
            commentHasError,
            subject = "Plugin Feedback from Form";

        if (!comment) {
            commentHasError = true;
        }
        if (!email || !this.validateEmail(email)) {
            emailHasError = true;
        } else {
        }

        if (emailHasError || commentHasError) {
            this.setState({
                loading: false,
                emailError: emailHasError,
                commentError: commentHasError
            });
            return;
        }

        switch (this.props.host) {
            case "office":
                appInfo = `(${Office.context.host} ${Office.context.platform})`;
                subject = "Noun Project Office365 Add-In Feedback";
                break;
            case "adobe":
                appInfo = `(${this.props.adobeAgent})`;
                subject = "Noun Project Adobe Add-On Feedback";
                break;
            case "gsuite":
                subject = "Noun Project Google Add-On Feedback";
                break;
        }

        $this.setState({ loading: true });

        let formData = {
                request: {
                    requester: { email: email, name: email },
                    subject: subject,
                    comment: {
                        body: `${comment}

                ${appInfo}`
                    }
                }
            },
            success = function(data) {

                $this.setState({ loading: false, sent: true });
            };
        $.ajax({
            url: "https://thenounproject.zendesk.com/api/v2/requests.json",
            type: "POST",
            data: formData,
            success: success
        });
    }

    renderForm() {
        let commentInputClasses = ["input"],
            commentLabel,
            emailInputClasses = ["input"],
            emailLabel,
            userEmail;

        if (this.props.currentUser !== undefined) {
            if (!this.props.currentUser.is_anonymous) {
                // TODO: get user's email address somehow and set userEmail
            }
        }

        if (this.state.commentError) {
            commentInputClasses.push("error on");
            commentLabel = (
                <label htmlFor="feedback" className="on error show">
                    Please write feedback before you send.
                </label>
            );
        } else {
            commentLabel = (
                <label
                    htmlFor="feedback"
                    data-label-text="Tell us what you like, or what can be better."
                    className="on show"
                >
                    Tell us what you like, or what can be better.
                </label>
            );
        }

        if (this.state.emailError) {
            emailInputClasses.push("error on");
            emailLabel = (
                <label htmlFor="email" className="on error show">
                    Please provide a valid contact email
                </label>
            );
        } else {
            emailLabel = (
                <label
                    htmlFor="email"
                    data-label-text="Email Address"
                    className="on show"
                >
                    Contact email
                </label>
            );
        }

        return (
            <form
                className="new-form plugin-form"
                style={{ maxWidth: "600px", margin: "auto", width: "100%" }}
            >
                <ol>
                    <li className="padding-b-s">
                        <textarea
                            id="feedback"
                            className={commentInputClasses.join(" ")}
                            maxLength="254"
                            name="login"
                            type="text"
                            required=""
                            autoFocus="autofocus"
                            placeholder="Tell us what you like, or what can be better."
                        />
                        {commentLabel}
                        <label htmlFor="email" className="ui_icon ui_quote" />
                    </li>
                    <li className="padding-b-s">
                        <input
                            id="email"
                            className={emailInputClasses.join(" ")}
                            maxLength="254"
                            name="email"
                            type="text"
                            required=""
                            placeholder="Contact email"
                            defaultValue={userEmail}
                        />
                        {emailLabel}
                        <label htmlFor="email" className="ui_icon ui_email" />
                    </li>
                </ol>
                <button
                    className="button blue full-width ui_resend"
                    type="submit"
                    onClick={this.submitFeedback.bind(this)}
                >
                    <span>Send feedback</span>
                </button>
            </form>
        );
    }

    renderSuccess() {
        return (
            <div>
                <p>Thank you so much for your feedback.</p>

                <button
                    className="button blue full-width ui_arrow-right-line"
                    onClick={this.closeFeedback.bind(this)}
                >
                    <span>Got it</span>
                </button>
            </div>
        );
    }

    render() {
        let content = <Loading />;

        if (this.state.sent) {
            content = this.renderSuccess();
        }
        if (!this.state.loading && !this.state.sent) {
            content = this.renderForm();
        }

        return (
            <span>
                <div className="quick-nav">
                    <PluginToolbar />
                </div>
                <div
                    className="plugin-feedback"
                    style={{
                        background: "#000000",
                        color: "#FFFFFF",
                        padding: "50px 16px 50px",
                        minHeight: "100%"
                    }}
                >
                    <div className="plugin-menu-header">
                        <a
                            href="#"
                            className="menu-close"
                            onClick={this.closeFeedback.bind(this)}
                            title="Cancel"
                        >
                            <Icon
                                iconId="close.svg"
                                className="icon-14"
                                color="#FFFFFF"
                            />
                        </a>
                    </div>
                    <div
                        style={{
                            maxWidth: "600px",
                            margin: "auto",
                            width: "100%"
                        }}
                    >
                        <h1 className="font-large margin-b-l ">Feedback</h1>
                        {content}
                    </div>
                </div>

                <PluginFooter />
            </span>
        );
    }
}

function mapStateToProps(state, ownProps) {
    let host = state.plugin.host,
        currentUser,
        adobeAgent = state.plugin.adobeAgent;

    if (state.user.is_anonymous !== undefined) {
        currentUser = state.user;
    }

    return {
        host,
        currentUser,
        adobeAgent
    };
}

module.exports = connect(mapStateToProps, {})(PluginFeedback);
